import React from 'react';
import AsyncSelect from 'react-select/async'

const SelectResearchers = (props) => {

    const options = (search) => {
        var url = 'api/contacts/get-researchers';
        if (search) {
            url += '?search=' + search;
        }
        return fetch(url)
            .then(response => response.json())
            .catch(err => {
                console.log('Can\'t load areas of interest.');
            });
    }

    const handleOnChange = (options) => {
        if (props.onChange) {
            options = options.map(option => { option.id = option.id ? option.id : option.value; return option; })

            props.onChange(options);
        }
    }

    return (
        <div className="form-group">
            <label htmlFor={props.name}>{props.title}</label>
            <AsyncSelect name={props.name} value={props.value} defaultOptions loadOptions={options} onChange={handleOnChange} shouldReload={props.shouldReload} isMulti closeMenuOnSelect={false} getOptionValue={option => option['id']} getOptionLabel={option => `${option.name} (${option.email})`} />            
        </div>
    );
}

export default SelectResearchers;